module.exports = __webpack_public_path__ + "media/src/images/icons/photo_icon-2958cacc78296fda08731a9aaab1fe62.svg";